export default __webpack_public_path__ + "static/media/008.6d9a4015.jpg";